import React from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AnswerApplicationPage from "@/pages/app/user/answer-application";
import RunStatusBadge from "@/components/process-trigger/run-status-badge";
import { useTriggerRun } from "@/hooks/process-trigger/use-process-trigger";

// Answers the first form of a triggered process (route /to-do/:runId, emailed link).
const StartTriggeredApplicationPage: React.FC = () => {
  const { t } = useTranslation();
  const { runId = "" } = useParams();
  const { data: run, isLoading, isError } = useTriggerRun(runId);

  if (isLoading) {
    return <p className="text-center py-20 text-primary">{t("processManagement.loading")}</p>;
  }

  if (isError || !run) {
    return (
      <div className="text-center py-20 space-y-3">
        <p className="text-gray-700">{t("processTriggers.start.notFound")}</p>
        <Link to="/to-do" className="text-darkBlue underline">
          {t("processTriggers.start.backToTodo")}
        </Link>
      </div>
    );
  }

  if (run.status !== "AWAITING_USER" || !run.targetProcess.firstFormId) {
    return (
      <div className="max-w-md mx-auto text-center py-20 space-y-3">
        <p className="font-medium text-gray-900">{run.targetProcess.name}</p>
        <RunStatusBadge status={run.status} />
        <p className="text-gray-600">{t(`processTriggers.start.closed.${run.status}`)}</p>
        <Link to="/to-do" className="text-darkBlue underline">
          {t("processTriggers.start.backToTodo")}
        </Link>
      </div>
    );
  }

  return <AnswerApplicationPage key={run.id} triggerRun={run} />;
};

export default StartTriggeredApplicationPage;
